import { Link } from 'react-router-dom'

export function ImpressumPage() {
  return (
    <main className="mx-auto max-w-3xl space-y-6 p-8">
      <header>
        <h1 className="text-2xl font-semibold">Impressum</h1>
      </header>

      <section className="space-y-3 text-sm leading-6 text-muted-foreground">
        <p>
          Huebner Management GmbH
          <br />
          Im Reberle 8
          <br />
          FL-9494 Schaan
          <br />
          Liechtenstein
        </p>
        <p>
          E-Mail:{' '}
          <a
            className="font-medium text-foreground underline-offset-4 hover:underline"
            href="mailto:hartmut@huebner.io"
          >
            hartmut@huebner.io
          </a>
          <br />
          Telefon: +41 77 261 07 24
        </p>
        <p>MindKeep ist ein Prototyp von Hartmut Hübner / Huebner Management GmbH.</p>
      </section>

      <footer className="text-xs text-muted-foreground">
        <Link className="underline-offset-4 hover:underline" to="/legal/privacy">
          Datenschutzerklärung
        </Link>
        {' · '}
        <Link className="underline-offset-4 hover:underline" to="/legal/terms">
          Nutzungsbedingungen
        </Link>
      </footer>
    </main>
  )
}
